import { render } from "./BG_productionProcess.vue?vue&type=template&id=3e5a5962&scoped=true"
import script from "./BG_productionProcess.vue?vue&type=script&lang=js"
export * from "./BG_productionProcess.vue?vue&type=script&lang=js"

import "./BG_productionProcess.vue?vue&type=style&index=0&id=3e5a5962&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a5962"]])

export default __exports__